<template>
  <label class="basic-checkbox"
         :id="$props.id"
         :class="[checkboxClasses, {'invalid': $props.invalid}, {'disabled': isDisabled}]">
    <input type="checkbox"
           v-model="currentValue"
           :disabled="isDisabled"
           @change="handleChange">
    <span class="checkbox-box"></span>
    <span class="checkbox-label">
      <slot>{{$props.label}}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'base-checkbox',
  props: {
    value: {},
    id: String,
    name: String,
    label: String,
    trueValue: [String, Number, Boolean],
    falseValue: [String, Number, Boolean],
    invalid: Boolean,
    disabled: {
      type: [Boolean, String],
      default: false
    },
    variant: {
      type: String,
      default: 'red',
      validator: (value) => {
        const variants = ['red', 'green']
        return variants.includes(value)
      }
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => {
        const sizes = ['small', 'normal']
        return sizes.includes(value)
      }
    },
    verticalAlign: {
      type: String,
      default: 'start',
      validator: (value) => {
        const allowedAlignments = ['start', 'center', 'end']
        return allowedAlignments.includes(value)
      }
    },
    position: {
      type: String,
      default: 'left',
      validator: (value) => {
        const allowedPositions = ['left', 'right']
        return allowedPositions.includes(value)
      }
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.$props.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    checkboxClasses () {
      return {
        [`variant-${this.$props.variant}`]: this.$props.variant,
        [`size-${this.$props.size}`]: this.$props.size,
        [`position-${this.$props.position}`]: this.$props.position,
        [`valign-${this.$props.verticalAlign}`]: this.$props.verticalAlign
      }
    },
    isDisabled () {
      if (typeof this.$props.disabled === 'string') {
        return this.$props.disabled === 'disabled'
      }
      return this.$props.disabled
    }
  },
  methods: {
    handleChange (evt) {
      let value
      if (evt.target.checked) {
        value = this.$props.trueValue === undefined ? true : this.$props.trueValue
      } else {
        value = this.$props.falseValue === undefined ? false : this.$props.falseValue
      }
      this.$emit('change', value, evt)
    }
  }
}
</script>

<style scoped lang="scss" src="./base-comp-styles/base-checkbox.scss"></style>
